const url = 'unidades-orcamentarias';
class UnidadeOrcamentariaIntegracaoService {
    async getByOrgao(idOrgao) {
        const response = await window.$http.get(`${url}/orgao/${idOrgao}`);
        return response.data;
    }
}

export default new UnidadeOrcamentariaIntegracaoService();
